module.exports = __webpack_public_path__ + "static/media/commission-icon.6ceaf511.svg";